@use '../../scss/utility/functions' as utility;
@use './horizontal-scroll-vars';

:host {
  @include horizontal-scroll-vars.wb-horizontal-scroll-vars;

  display: block;
  overflow: hidden;
  position: relative;
}

:host([hide-arrow-navigation]) {
  @include horizontal-scroll-vars.wb-horizontal-scroll-hide-arrow-navigation-vars;
}

.container {
  margin: 0 calc(-1 * var(--wb-spacing-xxs));
  transition-property: -webkit-mask-size, mask-size;
  transition-duration: 0.3s;
  transition-timing-function: var(--wb-fade);
}

.has-mask {
  mask-image: var(--horizontal-scroll-mask-image);
  mask-size: var(--horizontal-scroll-mask-size);
  mask-position: var(--horizontal-scroll-mask-position);
  -webkit-mask-image: var(--horizontal-scroll-mask-image);
  -webkit-mask-size: var(--horizontal-scroll-mask-size);
  -webkit-mask-position: var(--horizontal-scroll-mask-position);
}

.mask-start {
  @include horizontal-scroll-vars.wb-horizontal-scroll-mask-start-vars;
}

.mask-end {
  @include horizontal-scroll-vars.wb-horizontal-scroll-mask-end-vars;
}

.mask-full {
  @include horizontal-scroll-vars.wb-horizontal-scroll-mask-full-vars;
}

.inner {
  display: flex;
  min-height: var(--horizontal-scroll-round-button-height);
  overflow-y: scroll;
  scrollbar-width: none;
  align-items: center;
  margin: 0 var(--wb-spacing-xxs);

  &::-webkit-scrollbar {
    display: none;
  }
}

.pixel {
  width: utility.wb-pixel-to-rem(1px);
  height: utility.wb-pixel-to-rem(1px);
  display: inline-block;
  flex-shrink: 0;
}

.arrow {
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.is-start {
  inset-inline-start: 0;
}

.is-end {
  inset-inline-end: 0;
}

:host([size='s']) {
  @include horizontal-scroll-vars.wb-horizontal-scroll-s-vars;
}

:host([size='m']) {
  @include horizontal-scroll-vars.wb-horizontal-scroll-m-vars;
}

:host([size='l']) {
  @include horizontal-scroll-vars.wb-horizontal-scroll-l-vars;
}

:host([is-rtl]) {
  @include horizontal-scroll-vars.wb-horizontal-scroll-rtl-vars;

  .mask-start {
    @include horizontal-scroll-vars.wb-horizontal-scroll-rtl-mask-start-vars;
  }

  .mask-end {
    @include horizontal-scroll-vars.wb-horizontal-scroll-rtl-mask-end-vars;
  }
}

:host([disable-clipping]) {
  @include horizontal-scroll-vars.wb-horizontal-scroll-disable-clipping;

  .mask-start::before,
  .mask-end::after,
  .mask-full::before,
  .mask-full::after {
    display: block;
    position: absolute;
    inset-block-start: 0;
    height: 100%;
    width: var(--horizontal-scroll-background-size);
    opacity: 0;
  }

  .has-mask.mask-start::before,
  .has-mask.mask-full::before {
    content: '';
    background: linear-gradient(90deg, var(--wb-horizontal-scroll-gradient-background) 50%, var(--wb-color-surface-none) 100%);
    inset-inline-start: 0;
    z-index: 1;
    opacity: 1;
  }

  .has-mask.mask-end::after,
  .has-mask.mask-full::after {
    content: '';
    background: linear-gradient(90deg, var(--wb-color-surface-none) 0%, var(--wb-horizontal-scroll-gradient-background) 50%);
    inset-inline-end: 0;
    opacity: 1;
  }
}

:host([hide-arrow-navigation][disable-clipping]) {
  .mask-start::before,
  .mask-full::before {
    background: linear-gradient(90deg, var(--wb-horizontal-scroll-gradient-background) 0%, var(--wb-color-surface-none) 100%);
  }

  .mask-end::after,
  .mask-full::after {
    background: linear-gradient(90deg, var(--wb-color-surface-none) 0%, var(--wb-horizontal-scroll-gradient-background) 100%);
  }
}

::slotted(*) {
  flex-grow: 1;
}

::slotted(.wb-subnavigation) {
  --subnavigation-popover-position: fixed;
}
